import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AllowPermission from "./components/AllowPermission";
import DigilockerDocument from "./components/DigilockerDocument";
import "./App.css";
import NotFound from "./components/NotFound";
import Home from "./components/Home";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/allow-permission" element={<AllowPermission />} />
        <Route path="/digilocker" element={<DigilockerDocument />} />
        <Route path="/error" element={<NotFound />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App;
